// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const NewAppText = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCloud.components.newAppText"
        description="New app text."
        defaultMessage="Onboard to Lens Cloud to obtain an app ID."
    />
);
NewAppText.displayName = "NewAppText";

export const Confirm = (): ReactElement => (
    <FormattedMessage id="apps.lensCloud.components.confirm" description="Confirm." defaultMessage="Confirm" />
);
Confirm.displayName = "Confirm";

export const SectionTitle = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCloud.components.sectionTitle"
        description="Section title."
        defaultMessage="Lens Cloud"
    />
);
SectionTitle.displayName = "SectionTitle";

export const Onboard = (): ReactElement => (
    <FormattedMessage id="apps.lensCloud.components.onboard" description="Onboard." defaultMessage="Onboard" />
);
Onboard.displayName = "Onboard";

export const NoAppText = (): ReactElement => (
    <FormattedMessage
        id="apps.lensCloud.components.noAppText"
        description="No app text."
        defaultMessage='You do not have a Lens Cloud application. Click "Onboard" to get started.'
    />
);
NoAppText.displayName = "NoAppText";
